import { createApp } from 'vue';
import Mp3ToOpusConverter from '@/Components/Mp3ToOpusConverter.vue';
import '@styles/app.css';

createApp(Mp3ToOpusConverter).mount('#mp3-to-opus-converter');
